import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col-lg-8 col-md-10 col-sm-12" }
const _hoisted_5 = { class: "table table-bordered table-hover" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.IsDownloading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("h1", null, "Downloading template...", -1 /* CACHED */),
                _createElementVNode("h3", null, "Depending on the project's size it may take from a few seconds to a few minutes.", -1 /* CACHED */)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "my-5" }, "Please select a workspace to download a template:", -1 /* CACHED */)),
                  _createElementVNode("table", _hoisted_5, [
                    _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Workspace"),
                        _createElementVNode("th", { style: {"width":"100px"} })
                      ])
                    ], -1 /* CACHED */)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Workspaces, (w) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: w.Id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(w.Name), 1 /* TEXT */),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary text-white",
                              onClick: ($event: any) => (_ctx.handleDownloadProjectTemplateCommand(w.Id))
                            }, "Download", 8 /* PROPS */, _hoisted_6)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}